var App = App || {};

App.SharedVideo = (function ($) {
    'use strict';

    function Init() {
        const landingMastheadVideos = $(".widget.widget-landing-masthead .landing-masthead-video");
        const videoWidgetVideos = $(".widget.widget-video .widget-video-video");

        if (landingMastheadVideos.length) {
            setupVideos(landingMastheadVideos);
        }

        if (videoWidgetVideos.length) {
            setupVideos(videoWidgetVideos);
        }
    }

    function setupVideos(videos) {
        videos.each(function () {

            const video = $(this);

            // click to stop all other videos before playing the clicked video
            video.find(".widget-video-button").on("click", function () {
                Play(video);
            });

            // if the video is in a modal, stop it from playing after modal close
            const modal = $(this).parents(".modal");
            if (modal.length > 0) {
                modal.on("hidden.bs.modal", function () {
                    Stop(video);
                });
            }

        });
    }

    function Play(video) {

        // stop all other videos before starting a new one
        $(".widget-video").each(function () { Stop($(this)); });

        const target = video.find(".widget-video-placeholder");
        const button = video.find(".widget-video-button");
        const source = button.attr("data-src");
        const title = button.attr("data-title");

        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                target.html(Youtube(source, title))
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                target.html(Vimeo(source, title));
                break;
            default:
                console.log("Could not locate video content");
        };

        button.hide();
        target.show();
    }

    function Stop(video) {

        const target = video.find(".widget-video-placeholder");
        const button = video.find(".widget-video-button");

        target.hide().html("");
        button.show();
    }

    function Youtube(source, title) {

        if (source.indexOf("autoplay") < 0) {
            if (source.indexOf('?') < 0) {
                source += "?autoplay=1";
            } else {
                source += "&autoplay=1";
            }
        }

        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
        return template;
    }

    function Vimeo(source, title) {
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>";
        return template;
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.SharedVideo.Init();
}); 
